// extracted by mini-css-extract-plugin
export default {"avatar_container":"user_avatar_container__3JwTc","img_wrap":"user_img_wrap__W9C-d","selectbox":"user_selectbox__HExs1","testClass":"user_testClass__SiQil"};